export default __webpack_public_path__ + "static/media/fb.633110e3.svg";